import React, { FC } from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { Grid, Tooltip, Typography } from '@inplayer-org/inplayer-ui';

// components
import CommonIcon from 'components/CommonIcon';
import Input from 'components/Fields/Input';
import { ContentContainer, CenterContent } from 'components/SharedStyledElements';
import FieldError from 'components/Fields/FieldError';

// own components
import ChannelTypeField from './fields/ChannelTypeField';
import VideoLatencyField from './fields/VideoLatencyField';

const { Container, Cell } = Grid;

const ContainerWithMargin = styled(Container)`
  margin-bottom: 1em;
`;

interface Props {
  title?: string;
  onCancel: () => void;
}

const ChannelOptions: FC<Props> = ({ title, onCancel }) => (
  <ContentContainer>
    <CenterContent>
      <ContainerWithMargin columns="1fr auto">
        {title && (
          <Cell>
            <Typography variant="h6">{title}</Typography>
          </Cell>
        )}
        <Cell left={2}>
          <Tooltip content="Cancel" placement="left">
            <CommonIcon tag="icon_button_cancel" name="close" onClick={onCancel} />
          </Tooltip>
        </Cell>
      </ContainerWithMargin>
      <Container columns={1}>
        <Cell>
          <Field tag="text_input_ivs_channel_name" name="name" component={Input} placeholder="Channel name" autoFocus />
          <FieldError name="name" />
        </Cell>
        <ChannelTypeField />
        <VideoLatencyField />
      </Container>
    </CenterContent>
  </ContentContainer>
);

export default ChannelOptions;
